var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#FAFAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tool_svg__clip0_7051_37969)",
    stroke: "#1A2047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.96 22.828H10.034c-.935 0-1.013-.875-1.101-1.933L8.658 16h14.633l-.275 4.895c-.107 1.062-.12 1.933-1.056 1.933v0zM23.29 16H8.659l.441-3.055a.977.977 0 01.973-.847h11.805c.495 0 .911.363.973.847L23.29 16v0zM12.668 12.033V9.995c0-.863.7-.823 1.564-.823h3.359c.863 0 1.564-.042 1.564.823v2.038",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.553 15.074h2.902v1.927h-2.902z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EFF0FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tool_svg__clip0_7051_37969"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 8.234)",
    d: "M0 0h18.001v15.533H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMSIgcng9IjE1LjUiIGZpbGw9IiNGQUZBRkMiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzcwNTFfMzc5NjkpIj4KPHBhdGggZD0iTTIxLjk1OTggMjIuODI4NEgxMC4wMzQ0QzkuMDk5MDcgMjIuODI4NCA5LjAyMDc5IDIxLjk1MjcgOC45MzI4OSAyMC44OTUzTDguNjU4MiAxNS45OTk5SDIzLjI5MDdMMjMuMDE2IDIwLjg5NTNDMjIuOTA4OSAyMS45NTc0IDIyLjg5NTEgMjIuODI4NCAyMS45NTk4IDIyLjgyODRWMjIuODI4NFoiIHN0cm9rZT0iIzFBMjA0NyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIzLjI5MDcgMTZIOC42NTgyTDkuMDk5MDcgMTIuOTQ0OEM5LjE2MDg4IDEyLjQ2MTEgOS41Nzg0IDEyLjA5OCAxMC4wNzE1IDEyLjA5OEgyMS44Nzc0QzIyLjM3MTkgMTIuMDk4IDIyLjc4OCAxMi40NjExIDIyLjg0OTggMTIuOTQ0OEwyMy4yOTA3IDE2VjE2WiIgc3Ryb2tlPSIjMUEyMDQ3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNjY4IDEyLjAzM1Y5Ljk5NDhDMTIuNjY4IDkuMTMxNTcgMTMuMzY3NiA5LjE3MTU4IDE0LjIzMjMgOS4xNzE1OEgxNy41OTA2QzE4LjQ1MzggOS4xNzE1OCAxOS4xNTQ5IDkuMTMwMDcgMTkuMTU0OSA5Ljk5NDhWMTIuMDMzIiBzdHJva2U9IiMxQTIwNDciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjE0LjU1MjciIHk9IjE1LjA3NDMiIHdpZHRoPSIyLjkwMiIgaGVpZ2h0PSIxLjkyNjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMxQTIwNDciLz4KPC9nPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjMxIiBoZWlnaHQ9IjMxIiByeD0iMTUuNSIgc3Ryb2tlPSIjRUZGMEZBIi8+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzcwNTFfMzc5NjkiPgo8cmVjdCB3aWR0aD0iMTguMDAxNCIgaGVpZ2h0PSIxNS41MzI5IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNyA4LjIzMzUyKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgTool as ReactComponent };